import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  Document,
  DocumentsAreaSections,
  DocumentType,
  FileDownloaded,
  communicationCategories,
} from '../../../../model';
import { UnreadDocumentsCount } from '../../../../model/documents/unread-documents-count';
import documentsRepository from '../../../../repositories/documents/documents-repository';
import { AsyncThunkConfig } from '../../../async-thunk-config';
import { communicationsDocumentsActions } from '../communications';
import {
  documentsListActions,
  DownloadDocumentsError,
} from '../documents-list';
import { offeringDocumentsActions } from '../offerings';

const actionsMap: { [key in DocumentsAreaSections]: any } = {
  DOCUMENTS: documentsListActions,
  INFO_OFFER: offeringDocumentsActions,
  COMMUNICATIONS: communicationsDocumentsActions,
};

export const retrieveUnreadDocumentsCounts = createAsyncThunk<
  UnreadDocumentsCount,
  void,
  AsyncThunkConfig<DownloadDocumentsError>
>('retrieve-unread-documents-counts', async (_, thunkApi) => {
  try {
    return await documentsRepository.getUnreadDocumentsCount(thunkApi);
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const markDocumentAsRead = createAsyncThunk<
  DocumentsAreaSections,
  {
    document: Document;
    documentsAreaSection: DocumentsAreaSections;
    documentType?: DocumentType;
  },
  AsyncThunkConfig<DownloadDocumentsError>
>('mark-document-as-read', async (value, thunkApi) => {
  try {
    const response = await documentsRepository.setDocumentAsRead(
      thunkApi,
      value.document
    );

    if (!response) {
      return thunkApi.rejectWithValue('GENERIC_ERROR');
    }

    thunkApi.dispatch(
      actionsMap[value.documentsAreaSection].markDocumentAsRead({
        id: value.document.id,
        type: value.documentType,
      })
    );

    if (value.documentType) {
      thunkApi.dispatch(
        documentsListActions.updateUnreadCounts(value.documentType)
      );
    }

    return value.documentsAreaSection;
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const downloadDocumentsFile = createAsyncThunk<
  FileDownloaded,
  { document: Document; token?: string },
  AsyncThunkConfig<DownloadDocumentsError>
>('download-documents-file', async (val, thunkApi) => {
  try {
    const document = val.document;
    const response = await documentsRepository.downloadDocument(
      thunkApi,
      document.id,
      val.token,
      !communicationCategories?.some((cat) => cat === document.category)
    );

    return {
      name: document.title,
      mediaType: 'pdf',
      blob: new Blob([response], { type: 'application/pdf' }),
    };
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});
